import React, { useState, useEffect } from 'react';
import { apiClient } from '../services/apiClient';

const BackendTest = () => {
  const [healthStatus, setHealthStatus] = useState(null);
  const [homeContent, setHomeContent] = useState(null);
  const [products, setProducts] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const testConnection = async () => {
      try {
        setLoading(true);
        
        // Test health endpoint
        const healthResponse = await apiClient.get('/health');
        console.log('Health check:', healthResponse);
        setHealthStatus(healthResponse);

        // Test home content endpoint
        const homeResponse = await apiClient.get('/home');
        console.log('Home content:', homeResponse);
        setHomeContent(homeResponse);

        // Test products endpoint
        const productsResponse = await apiClient.get('/products?limit=5');
        console.log('Products:', productsResponse);
        setProducts(productsResponse);

      } catch (err) {
        console.error('Backend connection error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    testConnection();
  }, []);

  if (loading) {
    return (
      <div className="p-8">
        <h2 className="text-2xl font-bold mb-4">Testing Backend Connection...</h2>
        <div className="animate-pulse">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-8">
        <h2 className="text-2xl font-bold mb-4 text-red-600">Backend Connection Error</h2>
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          <p className="font-bold">Error:</p>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold mb-6 text-green-600">✅ Backend Connected Successfully!</h2>
      
      <div className="space-y-6">
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-2">Health Check</h3>
          <pre className="bg-gray-100 p-3 rounded text-sm overflow-auto">
            {JSON.stringify(healthStatus, null, 2)}
          </pre>
        </div>

        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-2">Home Content</h3>
          <pre className="bg-gray-100 p-3 rounded text-sm overflow-auto max-h-64">
            {JSON.stringify(homeContent, null, 2)}
          </pre>
        </div>

        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-2">Products (First 5)</h3>
          <pre className="bg-gray-100 p-3 rounded text-sm overflow-auto max-h-64">
            {JSON.stringify(products, null, 2)}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default BackendTest;
